import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import AlertCircleSvg from 'images/v5/icons/alert-circle.svg';
import styles from './InputError.module.scss';
const TRANSITION_MS = 200;
function InputError({ message }) {
    const [displayedMessage, setDisplayedMessage] = useState(null);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        if (message) {
            setDisplayedMessage(message);
            const raf = requestAnimationFrame(() => setVisible(true));
            return () => cancelAnimationFrame(raf);
        }
        setVisible(false);
        const timer = setTimeout(() => setDisplayedMessage(null), TRANSITION_MS);
        return () => clearTimeout(timer);
    }, [message]);
    if (!displayedMessage)
        return null;
    return (React.createElement("div", { className: classNames(styles.wrap, {
            [styles.visible]: visible,
        }) },
        React.createElement("p", { className: classNames(styles.message) },
            React.createElement(AlertCircleSvg, { className: styles.icon }),
            displayedMessage)));
}
export default InputError;
